import axios from 'axios'
axios.defaults.withCredentials = true
import baseStore from '../../index'

const state = {
  fairItems: (localStorage.getItem("fairItems")) ? JSON.parse(localStorage.getItem('fairItems')) : [],
  loadingData: (localStorage.getItem("fairItems")) ? false : true
}

const mutations = {
  UPADATE_LOADING_DATA(state, payload) {
    console.log('loadingData', payload);
    state.loadingData = payload
  },
  UPDATE_FAIR_LIST(state, playload) {
    state.fairItems = playload
    //console.log(state.fairItems);
  }
}

const actions = {
  loadingData({ commit }, payload) {
    commit('UPADATE_LOADING_DATA', payload)
  },
  resetFairItems({ commit }) {
    console.log('resetFairItems');
    commit('UPDATE_FAIR_LIST', [])
  },
  async getFairItems ({ commit }, token) {
    console.log('getFairItems => offline: '+ baseStore.getters.offlineMode)
    if (baseStore.getters.offlineMode) {
      const localFairItems = JSON.parse(localStorage.getItem('fairItems'))
      commit('UPDATE_FAIR_LIST', localFairItems)
    } else {
      axios
      .get(baseStore.getters.apiPath +'fairs', {
          headers: {
            'Authorization': `JWT ${token}`
          }
        }
      )
      .then((response) => {
        console.log('getFairItems');
        //console.log(response);
        //response.data.error = "Messaggio errore"
        //response.data.login = true
        if (response.data.error) {
          global.showError(response.data.error, response.data.login)
        } else {
          localStorage.setItem('fairItems', JSON.stringify(response.data))
          commit('UPDATE_FAIR_LIST', response.data);
        }
      })
      .catch((error) => {
        global.showError(error)
        console.log("GET call unsuccessful :(", error);
      })
      /* .finally(() => {
        commit('UPADATE_LOADING_DATA', false)
      }) */;
    }
  },
  async partecipate(context, data) {
    console.log('partecipate => data: ', data)
		const token = localStorage.getItem("token");
    if (!baseStore.getters.offlineMode) {
      axios
      .post(baseStore.getters.apiPath +'partecipate', data, {
          headers: {
            'Authorization': `JWT ${token}` 
          }
        }
      )
      .then((response) => {
        //console.log('getFairItems');
        //response.data.error = "Messaggio errore"
        //response.data.login = true
        if (response.data.error) {
          global.showError(response.data.error)
        } else {
          window.alert("Booking memorized!")
        }
      })
      .catch((error) => {
        global.showError(error)
        console.log("GET call unsuccessful :(", error);
      });
    }
  },
  goBack() {
    history.back()
  },
}

const getters = {
  loadingData: (state) => state.loadingData,
  fairItems: (state) => state.fairItems,
  fairItemFromId: (state) => (id) => {
    //console.log("fairItemFromId - id: "+ id);
    return state.fairItems.find((fairItem) => fairItem.id === Number(id));
  }
}

const fairsModule = {
  state,
  mutations,
  actions,
  getters,
}

export default fairsModule
